import { render, staticRenderFns } from "./list-management-confirmation-dialog.vue?vue&type=template&id=161cf5fa&scoped=true&"
import script from "./list-management-confirmation-dialog.vue?vue&type=script&lang=ts&"
export * from "./list-management-confirmation-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./list-management-confirmation-dialog.vue?vue&type=style&index=0&id=161cf5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cf5fa",
  null
  
)

export default component.exports